import { render, staticRenderFns } from "./NormalSearchNav237.vue?vue&type=template&id=5897bb6a&scoped=true&"
import script from "./NormalSearchNav237.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav237.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897bb6a",
  null
  
)

export default component.exports